/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {SubscriptionTypeDetailsService} from "../services/subscription-type-details.service";
import {SubscriptionTypeResourceService} from "@well/resource-services";
import {SubscriptionTypeDtoModel} from "@well/domain";

@Injectable()
export class SubscriptionTypeEditService extends SubscriptionTypeDetailsService {

  constructor(protected subscriptionTypeResourceService: SubscriptionTypeResourceService) {
    super(subscriptionTypeResourceService);
  }

  save(resource: SubscriptionTypeDtoModel) {
    return this.subscriptionTypeResourceService.update(resource);
  }

}
